
// Letras proibidas no CNPJ conforme ENCAT (vazio até confirmação oficial das restrições)
export const CNPJ_FORBIDDEN_LETTERS: string = '';

export const cnpjMask = (value: string): string => {
    const cleaned = value
        .replace(/[^a-zA-Z0-9]/g, '')
        .toUpperCase()
        .slice(0, 14);

    if (cleaned.length <= 2) return cleaned;
    if (cleaned.length <= 5) return `${cleaned.slice(0, 2)}.${cleaned.slice(2)}`;
    if (cleaned.length <= 8) return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5)}`;
    if (cleaned.length <= 12) return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5, 8)}/${cleaned.slice(8)}`;
    return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5, 8)}/${cleaned.slice(8, 12)}-${cleaned.slice(12, 14)}`;
};

export const cleanCnpj = (value: string): string =>
    value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

const charValue = (char: string): number => char.charCodeAt(0) - 48;

const calcDv = (chars: string, weights: number[]): number => {
    const sum = chars.split('').reduce((acc, char, i) => acc + charValue(char) * weights[i], 0);
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
};

export const validateCNPJ = (cnpj: string): boolean => {
    const clean = cleanCnpj(cnpj);

    if (clean.length !== 14) return false;

    for (const char of clean) {
        if (/[A-Z]/.test(char) && CNPJ_FORBIDDEN_LETTERS.includes(char)) return false;
    }

    if (!/^\d$/.test(clean[12]) || !/^\d$/.test(clean[13])) return false;

    const isAlphanumeric = /[A-Z]/.test(clean);
    if (!isAlphanumeric && /^(.)\1+$/.test(clean)) return false;

    const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    const dv1 = calcDv(clean.slice(0, 12), weights1);
    if (dv1 !== parseInt(clean[12])) return false;

    const dv2 = calcDv(clean.slice(0, 13), weights2);
    if (dv2 !== parseInt(clean[13])) return false;

    return true;
};
